const CONFIGS = {
  API: process.env.NEXT_PUBLIC_API_URL,
  MODE: process.env.NEXT_PUBLIC_MODE,
  FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
  UPO_URL: process.env.NEXT_PUBLIC_UPO_URL,
  SOCKET_URL: process.env.NEXT_PUBLIC_SOCKET_URL,
  OPENAI_API_KEY: process.env.OPENAI_API_KEY,
  KEYTEXT: process.env.NEXT_PUBLIC_KEYTEXT,
  DISCORD_CLIENT_ID: process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID,
  DISCORD_CLIENT_SECRET: process.env.DISCORD_CLIENT_SECRET,
};

export default CONFIGS;
